import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TrackingNumber from '../components/TrackingNumber';
import { showUpdatedRxFormShippingAction } from '../../../reducers/rxForms';
import { useDispatch } from 'react-redux';
import { IconButton } from '@material-ui/core';
import { Edit as EditIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => {
  return {
    shipping: {
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column'
    },
    redText: {
      color: 'darkred'
    },
    greenText: {
      color: 'green'
    },
    boldText: {
      fontWeight: 'bold'
    }
  };
});

const ShippingColumn = ({ rxForm, collapsed, onClickTrackingNumber }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  if (!rxForm) {
    return '';
  }

  const courier = rxForm.courier;

  const handleUpdateRxFormShipping = () => {
    dispatch(showUpdatedRxFormShippingAction(rxForm));
  };

  return (
    <div className={classes.shipping}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <TrackingNumber rxForm={rxForm} onClickTrackingNumber={onClickTrackingNumber} />
        {collapsed && courier && (
          <div>
            Track:{' '}
            <a href={courier.link} rel="noopener noreferrer" target="_blank">
              {courier.name}
            </a>
            <IconButton color="primary" size="small" onClick={handleUpdateRxFormShipping}>
              <EditIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};

ShippingColumn.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  rxForm: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  onClickTrackingNumber: PropTypes.func.isRequired
};

ShippingColumn.defaultProps = {
  rxForm: null
};

export default ShippingColumn;
